var $ = require('jquery');

$(function () {

    if ($('.1300-insights').length > 0) {
        var sliders = $('.1300-insights__list_carousel');
        var resizeTimeout;
        sliders.each(function () {

            // only show arrows when there are 3+ insight slides
            var numInsights = $(this).find('.1300-insights__list_carousel_insight').length;
            var showArrows = numInsights > 2 ? true : false;
            var slider = $(this);
            slider.slick({
                arrows: showArrows,
                infinite: false,
                speed: 300,
                slidesToShow: 2,
                centerMode: false,
                centerPadding: '60px',
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ],
                rtl: window.GenericUtilities.isRTL()
            });

            //slider switches to full-width after the first successful slide transition
            slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                fullWidthAfterSlideTransition($(this), currentSlide, nextSlide, '.1300-insights-container');
            });

            //set the next arrow position and visibility on this slider after sliding
            slider.on('afterChange', function (event, slick, currentSlide) {
                nextArrowPositionCheck(slick);
            });
        });

        $(window).on('resize orientationchange', function () {
            window.clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function () {
                sliders.each(function () {
                    if ($(this)[0] && $(this)[0].slick) {
                        nextArrowPositionCheck($(this)[0].slick);
                    }
                });
            }, 250);
        });
    }
});